// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import wow from "wowjs"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import "./assets/styles/normalize.css"
import "./assets/styles/wave.css"
import "wowjs/css/libs/animate.css"

import companyData from "@/utils/companyMsg"

Vue.config.productionTip = false

Vue.prototype.companyData = companyData.companyData;
Vue.prototype.$wow = wow;

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js